// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "home",
    name: "home",
    meta: {
      title: "首页",
      tabbar: true,
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./Home"),
  },
  {
    path: "yun/phone",
    name: "yun.phone",
    meta: {
      title: "云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunPage.vue"),
  },
  {
    path: "yun/haima",
    name: "yun.haima",
    meta: {
      title: "海马云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunPageHaiMa.vue"),
  },
  {
    path: "yun/guoying",
    name: "yun.guoying",
    meta: {
      title: "国赢云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunPageGuoYi.vue"),
  },
  {
    path: "yun/sanjiuyou",
    name: "yun.sanjiuyou",
    meta: {
      title: "三九游云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunPageSanJiu.vue"),
  },
  {
    path: "yun/huaweiyun",
    name: "yun.huaweiyun",
    meta: {
      title: "华为云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunPageHuaWei.vue"),
  },
  {
    path: "/yunproblem",
    name: "yunproblem",
    meta: {
      title: "云手机常见问题",
    },
    component: () => import("./YunProblem.vue"),
  },
  {
    path: "/tutorial",
    name: "tutorial",
    meta: {
      title: "云手机教程",
    },
    component: () => import("./Tutorial.vue"),
  },
  {
    path: "/yunh5",
    name: "yunh5",
    meta: {
      title: "云手机h5",
      noheader: true,
    },
    component: () => import("./yunh5.vue"),
  },
  {
    path: "/group/management",
    name: "group.management",
    meta: {
      title: "分组管理",
      rightText: "新建分组",
      noTop: true,
      unpull: true,
    },
    component: () => import("./GroupManage.vue"),
  },
  {
    path: "/group/move/target",
    name: "group.move.target",
    meta: {
      title: "移动至当前分组",
      rightShow: true,
      noTop: true,
      unpull: true,
    },
    component: () => import("./GroupMoveTarget.vue"),
  },
  {
    path: "/group/change",
    name: "group.change",
    meta: {
      title: "更换分组",
      noTop: true,
    },
    component: () => import("./GroupChange.vue"),
  },
  {
    path: "/group/detail",
    name: "group.detail",
    meta: {
      title: "",
      noheader: true,
      unpull: true,
    },
    component: () => import("./GroupDetail.vue"),
  },
  {
    path: "/add/device",
    name: "add.device",
    meta: {
      title: "添加设备",
      noheader: true,
      unpull: true,
    },
    component: () => import("./AddDevice.vue"),
  },
  {
    path: "/batch/app/select",
    name: "batch.app.select",
    meta: {
      title: "批量选择",
      noheader: true,
      unpull: true,
    },
    component: () => import("./BatchAppSelect.vue"),
  },
  {
    path: "/batch/app/operate",
    name: "batch.app.operate",
    meta: {
      title: "批量操作",
      noheader: true,
      unpull: true,
    },
    component: () => import("./BatchAppOperate.vue"),
  },
  {
    path: "/sync/manage",
    name: "sync.manage",
    meta: {
      title: "群控功能",
      noheader: true,
      unpull: true,
    },
    component: () => import("./SyncManage.vue"),
  },
  {
    path: "/sync/GuoYiSyncPage",
    name: "sync.GuoYiSyncPage",
    meta: {
      title: "国营云同步",
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunGuoYiSyncPage.vue"),
  },
  {
    path: "/sync/YunSyncPage",
    name: "sync.YunSyncPage",
    meta: {
      title: "HSZ群控",
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunSyncPage.vue"),
  },
];
